export function isReadonlyAccount(account: any) {
  return !!account.readonly;
}

export function isAdmin(account: any) {
  return account.__typename === 'Admin';
}

export function isCompany(account: any) {
  return account.__typename === 'CompanyAccount';
}

export function isBrand(account: any) {
  return account.__typename === 'Brand';
}

export function isTrainer(account: any) {
  return account.__typename === 'TrainerAccount';
}

export function isCertifiedTrainer(account: any) {
  return isTrainer(account) && account.isCertified;
}

export function hasTrial(account: any) {
  return account.isTrial;
}

export function getTrialStatus(account: any) {
  return account.isTrial ? account.trial.status : undefined;
}

export function getTrialRemainingDays(account: any) {
  return account.isTrial ? account.trial.endsIn : undefined;
}

export function isTrialUnlimited(account: any) {
  return account.isTrial ? account.trial.endsIn === -1 : false;
}
